import Repository from '@/repositories/repository'

const BecomePartnerRepository = {
  async getBecomePartnerData(queryParams: any = {}) {
    const params = {
      ...queryParams
    }

    return await Repository('become-a-partner', 'page', params)
  }
}

export default BecomePartnerRepository
